import { BROADCASTCHANNEL_TYPES, SetupBroadcastChannel } from '@/Data/Functions/BroadcastChannels';
import { convertToUTC } from '@/Data/Functions/dateLocalisation';
import { DateTime } from 'luxon';

const AUTHITEMNAME = 'mtjwt',
    TWOFACTORAUTHNAME = 'twpfac';
const USEROBJECTNAME = 'authUserInfo';

function UserModel (
    name = 'LOGIN',
    username = 'your@email.com',
    groupId = 0,
    securityLevelName = 'NOT LOGGED IN',
    cashierNumber = 0,
    uid = 0,
    environment = 'Development',
    homeStoreClientRef = 0,
    securityLevel = 0) {
    this.name = name;
    this.username = username;
    this.groupId = groupId;
    this.securityLevelName = securityLevelName;
    this.cashierNumber = cashierNumber;
    this.shortName = name.split(' ')[0];
    this.userInitial = (name.length > 0 ? name.toUpperCase().charAt(0) : 'X');
    this.uid = uid;
    this.environment = environment;
    this.homeStoreClientRef = homeStoreClientRef;
    this.securityLevel = securityLevel;
}

const auth = {
    status () {
        const authObject = auth.get();

        return (typeof authObject === 'undefined' ||
            authObject === null ||
            authObject === '')
            ? false
            : true;
    },
    superStatus () {
        const token = auth.get();

        if (!token) {
            return false;
        }

        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const payload = JSON.parse(atob(base64));
            return payload.SuperUser === 'true';
        }
        catch {
            return false;
        }
    },
    get () {
        const cookieValueToReturn = GetTokenCookie(AUTHITEMNAME);

        return cookieValueToReturn;
    },
    get2FA () {
        return GetTokenCookie(TWOFACTORAUTHNAME);
    },
    userinfo () {
        let userCookieData = GetUserObjectCookie(),
            data = new UserModel();
        if (userCookieData != '' && userCookieData.length > 0) {
            data = JSON.parse(userCookieData);
        }

        return {
            status: (typeof data == 'object'),
            userinfo: data
        };
    },
    set (data) {
        if (typeof data.user.token != 'string') {
            throw `Value must be a string however value was passed in as a '${typeof data.user.token}'!`;
        }

        SetCookieByName(AUTHITEMNAME, 7, data.user.token);

        // Refresh token doesn't contain user data so don't try to update it
        if (data.user.name) {
            const userSaveData = new UserModel(
                data.user.name,
                data.user.username,
                data.user.groupId,
                data.user.securityLevelName,
                data.user.cashierNumber,
                data.user.uid,
                data.environment,
                data.user.homeStoreClientRef,
                data.user.securityLevel);

            SetCookieByName(USEROBJECTNAME, 7, JSON.stringify(userSaveData));
        }

        SetupUserStateBroadcastChannel();

        return true;
    },
    setTwoFactorAuth (token) {
        SetCookieByName(TWOFACTORAUTHNAME, 1, token);

        return true;
    },
    remove () {
        const toReturn = ((document.cookie = `${AUTHITEMNAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`)
            && (document.cookie = `${USEROBJECTNAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`));

        SetupUserStateBroadcastChannel();

        return toReturn;
    }
};

export default auth;

function GetTokenCookie (cookieName) {
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    let cookieValueToReturn = '';
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            cookieValueToReturn = c.substring(name.length, c.length);
        }
    }

    return cookieValueToReturn;
}

function SetCookieByName (cookieName, cookieExpiryInDays, cookieData) {
    const expiryDate = convertToUTC(DateTime.now().plus({ days: cookieExpiryInDays }));

    document.cookie = `${cookieName}=${cookieData}; expires=${expiryDate.toHTTP()}`;

    return true;
}

function SetupUserStateBroadcastChannel () {
    /* Create broadcast channel */
    const userBroadcast = SetupBroadcastChannel(BROADCASTCHANNEL_TYPES.CLOUD_MT_USER_CHANGED);

    /* Notify interested parties of change */
    userBroadcast.postMessage(true);
}

function GetUserObjectCookie () {
    const name = `${USEROBJECTNAME}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    let cookieValueToReturn = '';
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            cookieValueToReturn = c.substring(name.length, c.length);
        }
    }

    return cookieValueToReturn;
}
